module.exports = __webpack_public_path__ + "static/waze-moods-32264881bb27560b3e2241c638a79aed.gif";